import { useContext } from 'react'
import { SearchContext } from './search-context'
import { iconSizeOptions } from '../../../atoms/icons/icons-sizes'

const SearchLeadingIcon = ({
  icon,
  size = iconSizeOptions['ICON-M'],
  ...props
}) => {
  const { disabled, handleOpenInput } = useContext(SearchContext)

  if (!icon) {
    return null
  }

  const Icon = icon

  return (
    <Icon
      size={size}
      style={{
        opacity: disabled ? '0.4' : 1,
        cursor: disabled ? 'default' : 'pointer'
      }}
      onClick={handleOpenInput}
      {...props}
    />
  )
}

export default SearchLeadingIcon
